<template>
  <div class="ws-icon-title">
    <i
      v-if="icon"
      class="ws-icon-title__icon"
      :class="icon"
    />
    <img
      v-if="image"
      :src="image"
      class="ws-icon-title__img"
    >
    <WsText001
      h4
      bold
      class="ml-8"
    >
      <slot />
    </WsText001>
  </div>
</template>
<script>
export default {
  name: "WsIconTitle001",
  props: {
    icon: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
  },
};
</script>